import { render, staticRenderFns } from "./address.vue?vue&type=template&id=5e7b8285&scoped=true&"
import script from "./address.vue?vue&type=script&lang=ts&"
export * from "./address.vue?vue&type=script&lang=ts&"
import style0 from "./address.vue?vue&type=style&index=0&id=5e7b8285&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7b8285",
  null
  
)

export default component.exports